import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import ProgramDetailComponent from './ProgramDetailComponent';
import { Schedule, ProgramMemberDetail, Level } from './Types';
import {
  updateProgram,
  deleteProgram,
  createProgram,
  updateProgramLevel,
  updateProgramSchedules,
  updateProgramMembers,
  getProgramMembers
} from './Actions';
import { paths } from '../app/app.routes';
import { push } from 'react-router-redux';
import { getMember } from '../members/members.actions';

type OwnProps = {
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    updateProgram: (
      id: number,
      name: string,
      colorValue: string
    ) => dispatch(updateProgram(
      id,
      name,
      colorValue
    )),
    createProgram: (
      name: string,
      levels: string[],
      schedules: Schedule[],
      colorValue: string
    ) => dispatch(createProgram(name, levels, schedules, colorValue)),
    deleteProgram: (id: number) => dispatch(deleteProgram(id)),
    toPrograms: () => dispatch(push(paths.programs)),
    getMember: (id: number) => dispatch(getMember(id)),
    updateProgramLevels: (programId: number, levels: Level[]) => dispatch(updateProgramLevel(programId, levels)),
    updateProgramSchedules: (programId: number, schedules: Schedule[]) =>
      dispatch(updateProgramSchedules(programId, schedules)),
    updateProgramMembers: (programMemberDetails: ProgramMemberDetail[]) =>
      dispatch(updateProgramMembers(programMemberDetails)),
    getProgramMembers: (id: number) => dispatch(getProgramMembers(id)),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard))
  };
};

const mapStateToProps = (state: AppState, ownProps: OwnProps) => {
  return {
    programsState: state.programsState,
    levelsState: state.levelsState,
    membersState: state.membersState,
    authState: state.authState,
    adminState: state.adminState,
    programMemberState: state.programMemberState
  };
};

const ProgramDetail: React.ComponentClass<OwnProps> =
  ReactRedux.connect(mapStateToProps, mapDispatchToProps)(ProgramDetailComponent);

export default ProgramDetail;



// WEBPACK FOOTER //
// ./src/programs/ProgramDetail.tsx